<div *ngIf="visible$ | async" class="footer" style="display: flex; flex-direction: row; justify-content: flex-end;">
  <div style="display: flex; flex-direction: row; gap: 24px; justify-content: flex-end; align-items: center; ">
    <div class="name">
      &copy; Copyright 2020 - FCMAT
    </div>
  </div>
</div>
